import { ListItem } from '$components/ListItem/ListItem';
import {
  FragmentType,
  useFragment as getFragment,
} from '$contentful-gql/index';
import { makeUrlFromSegment, makeUrlFromUrlFragment } from '$providers/Url';
import {
  assetFragment,
  newsFragment,
  typeAssetFragment,
  urlFragment,
} from '$providers/common';

export function NewsCardProvider(props: {
  itemIndex: number;
  item: FragmentType<typeof newsFragment>;
}) {
  const { item, itemIndex } = props;

  const fields = getFragment(newsFragment, item);
  let url = null;
  let newTab = false;
  if (fields.type === 'news' && fields.linkedFrom.pageCollection.total > 0) {
    url = makeUrlFromSegment({
      url: fields.linkedFrom.pageCollection.items[0],
    });
  } else if (fields.type === 'press' && fields.url) {
    url =
      makeUrlFromUrlFragment({ url: getFragment(urlFragment, fields.url) }) ||
      {};
    newTab = !!(url.externalLink && !url.internalLink);
  }
  if (url === null) return null;

  const listAssetCollection = fields.assetsCollection.items.filter((asset) => {
    const assetFields = getFragment(typeAssetFragment, asset);
    return assetFields.context && assetFields.context.includes('List');
  });

  const organizationLogoAsset = getFragment(
    assetFragment,
    fields.organizationLogo,
  );

  return (
    <ListItem
      itemIndex={itemIndex}
      url={url}
      newTab={newTab}
      heading={fields.title}
      subHeading={fields.subtitle}
      tag={fields.type}
      assets={listAssetCollection}
      assetOverlay={fields.assetOverlay}
      organizationLogo={organizationLogoAsset}
      img={null}
    />
  );
}
